import React, { useState } from "react";
import { certsData } from "../../constant/constant";
import ProgressiveImage from "../ProgressiveImage";
const Certs = () => {
  const [expanded, setExpanded] = useState(false);
  const certificates = expanded ? certsData : certsData.slice(0, 3);
  const toggleExpanded = () => {
    const isCollapsing = expanded;
    setExpanded(!expanded);
    if (isCollapsing)
      window.requestAnimationFrame(() =>
        document.getElementById("certs")?.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
          block: "start",
        }),
      );
  };
  return (
    <section id="certs" className="section">
      <p className="eyebrow">Learning</p>
      <h2 className="section-title">Certificates & training</h2>
      <div className="certificate-grid">
        {certificates.map((cert) => (
          <a
            className="panel certificate-card"
            key={cert.title}
            href={cert.link || undefined}
            target={cert.link ? "_blank" : undefined}
            rel="noreferrer"
          >
            <ProgressiveImage src={cert.image} alt={cert.title} />
            <h3>{cert.title}</h3>
            <p>{cert.sub}</p>
          </a>
        ))}
      </div>
      <button
        className="button-secondary journey-button"
        onClick={toggleExpanded}
      >
        {expanded ? "Show less" : "View all certificates"}
      </button>
    </section>
  );
};
export default Certs;
